import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Transition,
  Container,
  Segment,
  Dropdown,
  Header,
  Button,
  Checkbox,
  Icon,
  Divider
} from 'semantic-ui-react';

import AssetTagSelection from './AssetTagSelection';
import { makeGet } from '../../../services/ServiceManager';

class FilterPanel extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedFiletype: {
        text: 'Image/Video',
        value: 'all'
      },
      searchParams: {},
      selectedTagOptions: {},
      tagOptions: {},
      ownAssetSelected: false,
      uploadedByOptions: []
    };
  }

  componentWillReceiveProps(nextProps) {
    const { shouldClearSearch, addedTagCategory } = nextProps;

    if (shouldClearSearch) {
      this.setState((prevState) => ({
        ...prevState,
        selectedTagOptions: {},
        selectedFiletype: {
          value: 'all',
          text: 'Image/Video'
        },
        ownAssetSelected: false,
        searchParams: {},
        uploadedByOptions: []
      }));
    } else if (addedTagCategory && addedTagCategory !== '') {
      const { tagOptions, selectedTagOptions } = this.state;

      const tagOptionsCopy = {
        ...tagOptions
      };

      const selectedTagOptionsCopy = {
        ...selectedTagOptions
      };

      delete tagOptionsCopy[addedTagCategory];
      delete selectedTagOptionsCopy[addedTagCategory];

      this.setState((prevState) => ({
        ...prevState,
        tagOptions: tagOptionsCopy,
        selectedTagOptions: selectedTagOptionsCopy
      }));
    }
  }

  onFilterPanelClose = () => {
    const { toggleFilterPanel } = this.props;

    toggleFilterPanel(false);
  };

  onFiletypeClick = (event, { value, text }) => {
    this.setState(
      {
        ...this.state,
        selectedFiletype: {
          text,
          value
        }
      },
      () => {
        const { searchAssets } = this.props;

        if (searchAssets) searchAssets('filetype', value);
      }
    );

    this.setState((prevState) => ({
      ...prevState,
      selectedFiletype: {
        text,
        value
      }
    }));
  };

  onUploadedByFieldClick = (event) => {
    event.preventDefault();

    const { uploadedByOptions } = this.state;

    if (uploadedByOptions.length === 0) {
      makeGet('service/asset/uploadedBy/all', null).then((response) => {
        const { statusCode, result } = response;

        if (statusCode === 200) {
          this.setState((prevState) => ({
            ...prevState,
            uploadedByOptions: result.map((uploadedBy) => ({
              key: `option_uploaded_by_${uploadedBy}`,
              text: uploadedBy,
              value: uploadedBy
            }))
          }));
        }
      });
    }
  };

  onSearchUploadedByChange = (event, { value }) => {
    this.setState(
      {
        ...this.state,
        searchParams: {
          ...this.state.searchParams,
          uploadedBy: value
        }
      },
      () => {
        const { searchAssets } = this.props;

        if (!searchAssets) return;
        searchAssets('uploaded_by', value);
      }
    );
  };

  onOwnAssetClick = (event, { checked }) => {
    event.preventDefault();

    const { user, displayError, searchAssets } = this.props;
    const { email } = user || {};

    if (!email || email.trim() === '') {
      displayError({
        type: 'INVALID_USER',
        title: 'Invalid User Info.',
        message: 'The user email address is not valid.'
      });

      this.setState((prevState) => ({
        ...prevState,
        ownAssetSelected: false
      }));

      return;
    }

    if (searchAssets) searchAssets('uploaded_by', checked ? email : '');

    this.setState((prevState) => ({
      ...prevState,
      ownAssetSelected: checked
    }));
  };

  updateTagOptions = (tagOption, callback) => {
    const keys = Object.keys(tagOption);

    if (keys.length !== 1) {
      throw new Error(
        'The parameter has more or less keys than expected. Please check where it was called.'
      );
    }

    const key = keys[0];

    this.setState(
      {
        ...this.state,
        tagOptions: {
          ...this.state.tagOptions,
          [key]: tagOption[key]
        }
      },
      () => {
        if (callback) callback();
      }
    );
  };

  updateSelectedTagOptions = (category, options) => {
    this.setState(
      {
        ...this.state,
        selectedTagOptions: {
          ...this.state.selectedTagOptions,
          [category]: options
        }
      },
      () => {
        // options is the list of selection dropdown option.
        // Since options[i].text is the value in asset_tag, we need
        // the list of selected option.text.
        const values = options.map((option) => option.text);

        const { searchAssets } = this.props;

        if (searchAssets) searchAssets(category, values);
      }
    );
  };

  toggleArchiveMode = () => {
    const { toggleArchiveMode } = this.props;
    if (toggleArchiveMode) {
      toggleArchiveMode();
    }
  };

  render() {
    const {
      openFilterPanel,
      shouldClearSearch,
      inArchiveMode,
      user
    } = this.props;
    const {
      selectedFiletype,
      tagOptions,
      selectedTagOptions,
      ownAssetSelected,
      searchParams,
      uploadedByOptions
    } = this.state;
    const { text: selectedFiletypeText } = selectedFiletype;
    const applyGuestFilter = ['NU'].includes(user.groups[0]);

    return (
      <Container
        fluid
        style={{
          height: '100%',
          position: 'absolute',
          display: openFilterPanel ? 'block' : 'none',
          zIndex: 10
        }}
      >
        <Transition.Group
          animation="fade down"
          duration={300}
          style={{
            height: '100%',
            width: '100%'
          }}
        >
          {openFilterPanel && (
            <div
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: openFilterPanel
                  ? 'rgba(255, 255, 255, 0.5)'
                  : 'white'
              }}
            >
              <Segment
                style={{
                  height: '100%',
                  width: '30%',
                  overflowY: 'auto',
                  float: 'right'
                }}
              >
                <Container fluid style={{ height: '5em' }}>
                  <Header as="h1" content="Filter" floated="left" />
                  <Button
                    basic
                    icon
                    floated="right"
                    onClick={this.onFilterPanelClose}
                  >
                    <Icon name="close" />
                  </Button>
                </Container>
                <Container fluid style={{ marginBottom: '1em' }}>
                  <Dropdown
                    text={selectedFiletypeText}
                    icon="filter"
                    floating
                    labeled
                    button
                    className="icon"
                    onClick={(event) => {
                      event.preventDefault();
                    }}
                  >
                    <Dropdown.Menu>
                      <Dropdown.Header
                        icon="tags"
                        content="Filter by file type"
                      />
                      <Dropdown.Divider />
                      <Dropdown.Item
                        onClick={this.onFiletypeClick}
                        value="all"
                        text="Image/Video"
                      />
                      <Dropdown.Item
                        onClick={this.onFiletypeClick}
                        text="Image"
                        value="image"
                      />
                      <Dropdown.Item
                        onClick={this.onFiletypeClick}
                        value="video"
                        text="Video"
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                  <Divider hidden />
                  <Checkbox
                    toggle
                    label="Only show my assets"
                    disabled={applyGuestFilter}
                    checked={ownAssetSelected}
                    onChange={this.onOwnAssetClick}
                    style={{ marginLeft: '1em' }}
                  />
                </Container>

                <Container fluid>
                  <Dropdown
                    fluid
                    clearable
                    id="uploadedByDropdown"
                    placeholder="Uploaded By"
                    selection
                    disabled={applyGuestFilter}
                    options={uploadedByOptions}
                    onClick={this.onUploadedByFieldClick}
                    onChange={this.onSearchUploadedByChange}
                    value={
                      searchParams && searchParams.uploadedBy
                        ? searchParams.uploadedBy
                        : undefined
                    }
                    style={{ marginBottom: '1em' }}
                  />

                  <AssetTagSelection
                    allowAdditions={false}
                    tagOptions={tagOptions}
                    shouldClearSearch={shouldClearSearch}
                    updateTagOptions={this.updateTagOptions}
                    updateSelectedTagOptions={this.updateSelectedTagOptions}
                    selectedTagOptions={selectedTagOptions}
                    containerComponent="FILTER_PANEL"
                    user={user}
                  />
                  <Divider fitted />
                </Container>
                <Divider hidden />

                <Checkbox
                  label="Search Archived Assets"
                  toggle
                  onChange={this.toggleArchiveMode}
                  checked={inArchiveMode}
                />
              </Segment>
            </div>
          )}
        </Transition.Group>
      </Container>
    );
  }
}

FilterPanel.propTypes = {
  searchAssets: PropTypes.func.isRequired
};
export default FilterPanel;



// WEBPACK FOOTER //
// ./src/components/common/AssetGalleryV2/FilterPanel.jsx